const getNonceScript = (nonce) => {
  return `window.viewability.setNonceForCSP('${nonce}');`;
};

module.exports = getNonceScript;
